import axios from "axios";
import { DEVELOPMENT_URL } from "../constants/apiUrl";

export default axios.create({
    baseURL: DEVELOPMENT_URL
})